module.exports = __webpack_public_path__ + "img/water.5ad2b68f.jpg";